package com.essntl.features.service.ui.addextraservice

import com.essntl.core.utils.utils.loadingmanager.LoadingManager
import com.essntl.core.utils.viewmodel.*
import com.essntl.features.service.domain.model.service.ServiceFilterOptions
import com.essntl.features.service.domain.model.service.ServiceModel
import com.essntl.features.service.domain.repository.ServiceRepository
import com.essntl.features.service.domain.use_case.ExtraCategoryServiceUseCase
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.update

class AddExtraServiceViewModel(
    private val serviceRepository: ServiceRepository,
    private val extraCategoryServiceUseCase: ExtraCategoryServiceUseCase,
    private val state: MutableStateFlow<AddExtraServiceState>,
    override val scope: CoroutineScope,
    override val loadingManager: LoadingManager,
) : ViewModel {
    fun onEvent(event: AddExtraServiceEvent) {
        when (event) {
            // Extra service
            is AddExtraServiceEvent.UpdateExtraServiceFields -> updateExtraServiceFields(event)
            is AddExtraServiceEvent.AddExtraService -> addExtraService()

            // Service
            is AddExtraServiceEvent.LoadExtraCategoryServices -> loadMoreExtraCategoryServices()
            is AddExtraServiceEvent.EditFilterOptions -> editFilterOptions(event.filterOptions)
            is AddExtraServiceEvent.AddService -> addService(event)
            is AddExtraServiceEvent.UpdateService -> updateService(event)
        }
    }

    private fun updateExtraServiceFields(event: AddExtraServiceEvent.UpdateExtraServiceFields) {
        state.value.extraService.value = event.extraService
    }

    private fun addExtraService() =
        getData(
            getData = { serviceRepository.insertExtraService(state.value.extraService.value) },
            getState = { state.value.addExtraService },
            setState = { state.value = state.value.copy(addExtraService = it) },
        )

    private fun loadMoreExtraCategoryServices(ignoreLoading: Boolean = false) {
        if (!ignoreLoading && state.value.getAllExtraCategoryService.isLoading) return

        getPaginationData(
            getData = {
                val nextPage = state.value.getAllExtraCategoryService.loadedPages + 1L
                extraCategoryServiceUseCase
                    .getAllExtraServices(
                        page = nextPage,
                        filterOptions = state.value.filterOptions,
                    )
                    .map { list ->
                        list.filter { service ->
                            state.value.getAllExtraCategoryService.data.none { it.id == service.id }
                        }
                    }
            },
            getState = { state.value.getAllExtraCategoryService },
            setState = { state.value = state.value.copy(getAllExtraCategoryService = it) },
            ignoreLoading = ignoreLoading,
        )
    }

    private fun editFilterOptions(
        filterOptions: ServiceFilterOptions,
        ignoreFiltering: Boolean = false,
    ) {
        if (!ignoreFiltering && filterOptions == state.value.filterOptions) return
        state.update {
            it.copy(
                filterOptions = filterOptions,
                getAllExtraCategoryService = PaginationState.loading(),
            )
        }

        loadMoreExtraCategoryServices(ignoreLoading = true)
    }

    private fun addService(event: AddExtraServiceEvent.AddService) =
        getData(
            getData = {
                extraCategoryServiceUseCase.insertExtraCategoryService(
                    ServiceModel.empty.copy(title = event.title),
                )
            },
            getState = { state.value.addService },
            setState = { state.value = state.value.copy(addService = it) },
        )

    private fun updateService(event: AddExtraServiceEvent.UpdateService) =
        state.update {
            it.copy(service = event.service)
        }
}